import { NgModule } from '@angular/core';

function flatMap<U, This = undefined>(callback: (this: This, value: any, index: number, array: any[]) => U | ReadonlyArray<U>,
                                      thisArg?: This): U[] {
    return Array.prototype.concat.apply([], this.map(callback));
}


declare global {
    interface Array<T> {
        //flat(): Array<T>;
        flatMap<U, This = undefined> (
            callback: (this: This, value: T, index: number, array: T[]) => U | ReadonlyArray<U>,
            thisArg?: This
        ): U[]

        /** Bu array'in verilen diğer array'dan fazla veya eksik bir item'ı varsa true döner.  **/
        hasDifferentItemsFrom(otherArray: Array<T>): boolean;
        /** Bu array'de olup diğer array'de olmayan item'ları döner.  **/
        getMissingItemsFor(otherArray: Array<T>): Array<T>;
    }
}

Array.prototype.flatMap = flatMap;
Array.prototype.hasDifferentItemsFrom = function (otherArray: Array<any>): boolean {
    if (!otherArray) return this.length > 0;

    return otherArray.length != this.length ||
        this.some(it => !otherArray.includes(it)) ||
        otherArray.some(it => !this.includes(it));
};

Array.prototype.getMissingItemsFor = function (otherArray: Array<any>): Array<any> {
    if (!otherArray) return [];
    return this.filter(it => !otherArray.includes(it))
};
